t = require('views/internal/teacup-with-helpers')('member_account')

module.exports = ->
  t.div '.window-module.u-clearfix', ->

    t.div '.window-module-title', ->
      t.h3 ->
        t.format 'account-details'

    t.a '.big-link.js-change-name-and-bio', { href: '#' }, ->
      t.span '.text', ->
        t.format 'change-name-initials-or-bio'

    t.a '.big-link.js-change-avatar', { href: '#' }, ->
      t.span '.text', ->
        t.format 'change-avatar'

    if t.mustacheVar('canUsePassword')
      t.a '.big-link.js-change-password', { href: '#' }, ->
        t.span '.text', ->
          t.mustacheBlock 'hasPassword', ->
            t.format 'change-password'
          t.mustacheBlockInverted 'hasPassword', ->
            t.format 'set-password'

    t.a '.big-link.js-change-email', { href: '#' }, ->
      t.span '.text', ->
        t.format 'change-email'

    t.a '.big-link.js-change-locale', { href: '#' }, ->
      t.span '.text', ->
        t.format 'change-locale'

  t.mustacheBlock 'showMobileLoginPassword', ->
    t.div '.window-module.u-clearfix', ->

      t.div '.window-module-title', ->
        t.h3 ->
          t.format 'mobile-application-sign-in'

      t.div '.u-gutter', ->
        t.input '.js-mobile-temp-password',
          type: 'button'
          value: t.l('generate-mobile-login-password')

  t.div '.window-module.js-credentials-section', ->
    t.div '.window-module-title', ->
      t.h3 ->
        t.format 'credentials'

    t.div '.js-credentials-list.u-gutter', ->
      t.div '.spinner.loading'

    t.div '.u-gutter', ->
      t.input '.js-add-email', { type: 'button', value: t.l('add-a-new-email-address') }

  t.div '.window-module.u-clearfix', ->

    t.div '.window-module-title', ->
      t.h3 ->
        t.format 'notifications'

    t.a '.big-link.js-change-email-freq', { href: '#' }, ->
      t.span '.text', ->
        t.format 'change-notification-email-frequency'

    t.mustacheBlock 'canAllowDesktopNotifications', ->
      t.a '.big-link.js-allow-desktop-notifications', { href: '#' }, ->
        t.span '.text', ->
          t.format 'allow-desktop-notifications'

  t.div '.window-module.u-clearfix', ->

    t.div '.window-module-title', ->
      t.h3 ->
        t.format 'accessibility'

    t.a '.big-link.js-toggle-cb-mode', { href: '#' }, ->
      t.span '.text', ->
        t.mustacheBlock 'cbEnabled', ->
          t.format 'disable-color-blind-friendly-mode'
        t.mustacheBlockInverted 'cbEnabled', ->
          t.format 'enable-color-blind-friendly-mode'

  t.div '.window-module', ->

    t.div '.window-module-title', ->
      t.h3 ->
        t.format 'applications'

    t.div '.js-member-applications', ->
      t.div '.spinner.loading'

  t.div '.window-module', ->

    t.div '.window-module-title', ->
      t.h3 ->
        t.format 'sessions'

    t.div '.js-member-sessions.u-gutter', ->
      t.div '.spinner.loading'

  t.div '.window-module.u-clearfix', ->

    t.div '.window-module-title', ->
      t.h3 ->
        t.format 'two-factor-auth'

    t.a '.big-link.js-configure-2fa', { href: '/2fa' }, ->
      t.span '.text', ->
        t.format 'configure-two-factor-authentication'

  t.div '.window-module', ->
    t.a '.quiet-button.u-gutter.js-confirm-delete-member', { href: '#', style: 'margin-top: 32px;' }, ->
      t.format 'permanently-delete-your-entire-account-forever'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/member_account.coffee